import { createContext } from "react";

import { Module } from "types/generated";
import { AccessResult } from "utils/access";

type ModuleSettingsContextValue = {
  module: Module;
  canManageModule: AccessResult;
};

export const ModuleSettingsContext = createContext<ModuleSettingsContextValue | undefined>(
  undefined
);
